import React from 'react';

/**
 * Process Selector Component
 * Allows user to select between full project scope or specific process scope for chat
 */
const ProcessSelector = ({ processes = [], selectedProcessId, onProcessChange, isLoading = false }) => {
  return (
    <div className="flex items-center gap-2">
      <label htmlFor="process-selector" className="text-sm font-medium flex-shrink-0" style={{color:'rgba(255,255,255,0.65)'}}>  
        Chat Scope:
      </label>
      <select
        id="process-selector"
        value={selectedProcessId || ''}
        onChange={(e) => onProcessChange(e.target.value || null)}
        disabled={isLoading || processes.length === 0}
        className="block flex-1 min-w-0 px-3 py-2 rounded-md shadow-sm focus:outline-none sm:text-sm disabled:opacity-40 disabled:cursor-not-allowed" style={{background:'var(--tqa-surface-2)',border:'1px solid var(--tqa-border-dark)',color:'rgba(255,255,255,0.85)'}}
      >
        <option value="">Full Project (All Processes)</option>
        {processes.map((process) => (
          <option key={process.id} value={process.id}>
            {process.name}
            {process.technicalName && ` (${process.technicalName})`}
            {process.version && ` - v${process.version}`}
          </option>
        ))}
      </select>
      
      {processes.length === 0 && !isLoading && (
        <span className="text-xs" style={{color:'rgba(255,255,255,0.4)'}}>No processes available</span>
      )}
      
      {selectedProcessId && (
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium" style={{background:'rgba(130,255,207,0.15)',color:'var(--tqa-green)'}}>
          Process Mode
        </span>
      )}
    </div>
  );
};

export default ProcessSelector;
